import { useState } from "react";
import { DataTable } from "../../components/organisms/DataTable";
import { paginacion } from "../../utils/paginacion/paginacion";
import { EstudianteGrupoCard } from "./EstudianteGrupoCard";

const ESTUDIANTES_POR_PAGINA = 15;

export const EstudianteGrupoList = ({ estudiantes = [], onDelete }) => {
  const [paginaActual, setPaginaActual] = useState(1);

  const {
    objetosEnPagina: estudiantesEnPagina,
    paginas,
    paginaInicial,
    paginaFinal,
  } = paginacion(paginaActual, estudiantes, ESTUDIANTES_POR_PAGINA);

  const columnas = [
    "#",
    "Nombre",
    "Apellido",
    "Código",
    "Teléfono",
    "CI",
    "Género",
    "Crédito",
    "Tipo de Admisión",
    "Nota Final",
    "Estado",
    "Opciones",
  ];

  const mostrarEstudiantes = estudiantesEnPagina.length > 0;

  return (
    <DataTable
      columnas={columnas}
      paginas={paginas}
      paginaInicial={paginaInicial}
      paginaFinal={paginaFinal}
      paginaActual={paginaActual}
      setPaginaActual={setPaginaActual}
    >
      {mostrarEstudiantes ? (
        estudiantesEnPagina.map((estudiante, i) => (
          <EstudianteGrupoCard
            key={estudiante?.estudiante?.idEstudiante || i}
            estudiante={estudiante}
            index={(paginaActual - 1) * ESTUDIANTES_POR_PAGINA + i + 1}
            onDelete={onDelete}
          />
        ))
      ) : (
        <tr>
          <td colSpan={columnas.length} className="text-center py-4">
            No hay estudiantes inscritos
          </td>
        </tr>
      )}
    </DataTable>
  );
};
